import strings from './strings';

/* istanbul ignore file  */
export default function getString(stringId, options) {
  if (!strings[stringId]) {
    throw new Error(
      'getString failed: ' + stringId + ' not found in src/strings.js'
    );
  }

  let string = strings[stringId]['en-US'];

  if (options && typeof options === 'object') {
    Object.keys(options).forEach(key => {
      const value = options[key];
      string = string.replace(new RegExp('{' + key + '}', 'g'), value);
    });
  }

  return string;
}
